module.exports = __webpack_public_path__ + "img/list_Portrait_07.e7809f3c.jpeg";